module.exports = __webpack_public_path__ + "static/assets/e4e0f50cfd6f599668b53f87e74d1a7e.svg";